export * from './deck.service';
import { DeckService } from './deck.service';
export const APIS = [DeckService];
